// extracted by mini-css-extract-plugin
export default {"cabinet":"Cabinet_cabinet__aQexC","cabinetActive":"Cabinet_cabinetActive__FnWh3"};